'use client';

import React from 'react';
import PropTypes from 'prop-types';

import ConnectedAccounts from './ConnectedAccounts';
import Icon from '../Icon';
import { t } from '../../i18n';
import s from './Toolbar.module.scss';

/**
 * Who is logged in, which client accounts they can switch to, and the way out.
 *
 * The content of the account popover, shared by the desktop toolbar and the
 * mobile menu so the two cannot drift: the same rows, the same words, one
 * stylesheet. The mobile menu keeps Log out in its own footer and so asks for
 * no logoutUrl here.
 */
export const AccountMenu = ({ user, dashboards = [], logoutUrl = null }) => (
    <>
        <div className={s.PopoverUser}>
            <span className={s.PopoverLabel}>{t('toolbar.loggedInAs')}</span>
            <span className={s.PopoverUserName}>{user?.email}</span>
        </div>

        <ConnectedAccounts dashboards={dashboards} />

        {!!logoutUrl && (
            <div className={s.PopoverLogout}>
                <a className={s.LogoutLink} href={logoutUrl} />
                <span>{t('general.logout')}</span>
                <Icon name="Logout" />
            </div>
        )}
    </>
);

AccountMenu.propTypes = {
    user: PropTypes.shape({
        name: PropTypes.string,
        email: PropTypes.string,
    }),
    // The client accounts this user can reach, the active one among them.
    dashboards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            url: PropTypes.string,
            title: PropTypes.string,
            isActive: PropTypes.bool,
            listImage: PropTypes.object,
        })
    ),
    // Omitted where the surrounding chrome already offers a way out.
    logoutUrl: PropTypes.string,
};

export default AccountMenu;
